/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface LoginValidator {
  validateLogin(username: string, password: string): Promise<LoginResult>;
}
export class LoginResult {
  constructor(public readonly ok: boolean, public readonly message: string) {}

  static success(message = 'Login efetuado com sucesso!'): LoginResult {
    return new LoginResult(true, message);
  }

  static fail(message = 'Falha ao efetuar login') {
    return new LoginResult(false, message);
  }
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginComponent {
  @Input() usernameInputLabel = 'Usuário';
  @Input() validator: LoginValidator;

  loginForm = this.fb.group({
    username: '',
    password: '',
  });

  constructor(private snackbar: MatSnackBar, private fb: FormBuilder) {}

  async onLoginClick() {
    if (!this.validator) {
      console.warn('Validador de login não está definido');
      return;
    }
    const { username, password } = this.loginForm.value;
    const result = await this.validator.validateLogin(username, password);
    if (!result.ok) {
      this.snackbar.open(result.message, 'OK', {
        duration: 3000,
      });
    }
  }
}
